<!-- Product Category creation form -->
<form [formGroup]="form" (ngSubmit)="createNew()">
    <div>
        <label for="name">Name:</label>
        <input type="text" id="name" formControlName="name">
    </div>
    <div>
        <label for="description">Description:</label>
        <input type="text" id="description" formControlName="description">
    </div>
    <div>
        <label for="active">Active:</label>
        <select id="active" formControlName="active">
            <option value="true">True</option>
            <option value="false">False</option>
        </select>
    </div>
    <button type="submit">Create Product Category</button>
</form>
<div *ngIf="id">Created Product Category ID: {{id}}</div>

<!-- Show all product categories toggle -->
<button (click)="toggleShowProductCategories()">
    {{showProductCategories ? 'Hide Product Categories' : 'Show All Product Categories'}}
</button>

<!-- Table shows all product categories with controls for update and delete -->
<table *ngIf="showProductCategories">
    <thead>
        <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Description</th>
            <th>Active</th>
            <th>Created</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let productCategory of productCategories; let i = index">
            <td>{{productCategory.id}}</td>
            <td>
                <input *ngIf="productCategory.isEditing" type="text" [(ngModel)]="productCategory.name">
                <span *ngIf="!productCategory.isEditing">{{productCategory.name}}</span>
            </td>
            <td>
                <input *ngIf="productCategory.isEditing" type="text" [(ngModel)]="productCategory.description">
                <span *ngIf="!productCategory.isEditing">{{productCategory.description}}</span>
            </td>
            <td>
                <select *ngIf="productCategory.isEditing" [(ngModel)]="productCategory.active">
                    <option [value]="true">Yes</option>
                    <option [value]="false">No</option>
                </select>
                <span *ngIf="!productCategory.isEditing">{{productCategory.active ? 'Yes' : 'No'}}</span>
            </td>
            <td>
                <button *ngIf="!productCategory.isEditing" (click)="editProductCategory(productCategory)">Edit</button>
                <button *ngIf="productCategory.isEditing" (click)="updateProductCategory(productCategory)">Save</button>
                <button *ngIf="productCategory.isEditing" (click)="cancelEditing(productCategory)">Cancel</button>
                <button (click)="deleteProductCategory(productCategory.id)">Delete</button>
            </td>
        </tr>
    </tbody>
</table>